import React, {useState} from 'react';
import { Link, useParams } from "react-router-dom";
import Card from '../components/Structure/Card.tsx';
import Button from '../components/Form/Button.tsx';
import { useAuthlessApi } from '../features/auth/hooks/use-authless-api.ts';
import { ApiResponseType } from '../features/api/types.ts';
import TextInput from '../components/Form/TextInput.tsx';
import PasswordInputWithValidation from '../components/Form/PasswordInputWithValidation.tsx';
import Form from '../components/Form/Form.tsx';

export default function PasswordReset() {
    const [isFormLoading, setIsFormLoading] = useState(false);
    const { updatePassword } = useAuthlessApi();
    const { token } = useParams();
    const [acitvateSuccess, setAcitvateSuccess] = useState(false);
    const [passwordCheckPassed, setPasswordCheckPassed] = useState<boolean>(false);

    const [responseMessage, setResponseMessage] = useState<string>('');
    const [responseMessageClass, setResponseMessageClass] = useState('');
    
    const [formData, setFormData] = useState<any>({
        contact_number: '',
        newpassword: '',
        repeatpassword: ''
    });
    
    const handlePWFormChange = (inputFormData, inputPasswordCheckPassed) => {
        let formDataClone = structuredClone(formData);
        formDataClone = {...formDataClone, ...inputFormData};
        
        setPasswordCheckPassed(inputPasswordCheckPassed);
        setFormData(formDataClone);
    }

    const handleChange = (event, name = '', value = null) => {
        let formDataClone = structuredClone(formData);
        formDataClone = { ...formDataClone, [name ? name : event.target.name]: (value ? value : event.target.value) }

        setFormData(formDataClone);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setResponseMessage('');

        if (formData.newpassword !== formData.repeatpassword) {
            setResponseMessage('Neue Passwörter stimmen nicht überein');
            setResponseMessageClass('error');
            return;
        }

        setIsFormLoading(true);

        updatePassword(formData.contact_number, formData.newpassword, token!).then(res => {
            if (res.type === ApiResponseType.CLIENT_ERROR || res.type === ApiResponseType.SERVER_ERROR || res.type === ApiResponseType.FORM_INVALID) {
                setResponseMessage(res.payload.error);
                setResponseMessageClass('error');
                
            } else if (res.type === ApiResponseType.OK) {
                setResponseMessage('Passwort erfolgreich zurückgesetzt. Sie können sich jetzt im FPSB-Portal anmelden.');
                setResponseMessageClass('success');
                setAcitvateSuccess(true);
            }
            setIsFormLoading(false);
        }).catch(err => {
            setIsFormLoading(false);
        })
    }
    return (
        <Card
            p={'var(--spacing-2xl)'}
            gap={'var(--spacing-xl)'}
        >
            <h1 className="h3 align-center">Passwort zurücksetzen</h1>
            <Form 
                id="profile-settings-form" 
                className={`pw-reset-form`}
                handleSubmit={handleSubmit}
                isLoading={isFormLoading}
                responseMessage={responseMessage}
                responseMessageClass={responseMessageClass}
                customSubmit={true}
                unSavedChanges={false}
            >
                <div className="loader"></div>
                <TextInput
                    onChange={(e:any) => handleChange(e)}
                    value={formData.contact_number}
                    label='Kontaktnummer oder E-Mail-Adresse'
                    name='contact_number'
                    type='text'
                    ariaLabel='Kontaktnummer oder E-Mail-Adresse'
                    required
                    autocomplete='username'
                    disabled={acitvateSuccess}
                />
                <PasswordInputWithValidation 
                    outerChangeHandler={handlePWFormChange}
                    additionalHintUpper={false}
                />
                { acitvateSuccess ? (
                    <Link className="button button-primary float-center" to={`/`}>Login</Link>
                ) : (
                    <Button
                        fullWidth
                        buttonType='primary'
                        onClick={handleSubmit}
                        disabled={formData.newpassword.length <= 0 || !passwordCheckPassed}
                    >Abschicken</Button>
                ) }
                <p className="m-0 text-xs align-center" >zurück zur <Link className="text-xs" to={`/`}>Anmeldung</Link></p>
            </Form>
        </Card>
    )
}